import { render, staticRenderFns } from "./UserFriends.vue?vue&type=template&id=15de6dd5"
import script from "./UserFriends.vue?vue&type=script&lang=js"
export * from "./UserFriends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports